import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { X, Eye, EyeOff, Loader2, KeyRound } from "lucide-react";

export function ChangePasswordModal({ onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const inputCls = "w-full bg-[#0B0E14] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white outline-none focus:border-[var(--nik-blue)] transition-colors";

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) { toast.error("New passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      onClose();
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not update password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[80] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose} data-testid="change-password-modal">
      <div className="bg-[#121824] border border-white/10 rounded-2xl p-6 w-full max-w-sm fade-up relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 text-slate-400 hover:text-white"><X size={18} /></button>
        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[var(--nik-blue)] to-[#0047B3] flex items-center justify-center">
          <KeyRound size={22} className="text-white" />
        </div>
        <h2 className="font-display text-xl font-bold text-white mt-4">Change Password</h2>
        <p className="text-sm text-slate-400 mt-1">Update the password for your account.</p>
        <form onSubmit={submit} className="mt-5 space-y-3">
          <div className="relative">
            <input data-testid="cp-current-input" type={show ? "text" : "password"} required placeholder="Current password"
              value={current} onChange={(e) => setCurrent(e.target.value)} className={inputCls + " pr-11"} />
            <button type="button" data-testid="cp-show-btn" onClick={() => setShow((s) => !s)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white">
              {show ? <EyeOff size={17} /> : <Eye size={17} />}
            </button>
          </div>
          <input data-testid="cp-new-input" type="password" required placeholder="New password"
            value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} />
          <input data-testid="cp-confirm-input" type="password" required placeholder="Confirm new password"
            value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} />
          <button data-testid="cp-submit-btn" type="submit" disabled={busy}
            className="w-full bg-[var(--nik-blue)] hover:bg-[var(--nik-blue-hover)] text-white font-semibold py-2.5 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {busy && <Loader2 size={16} className="animate-spin" />} Update Password
          </button>
        </form>
      </div>
    </div>
  );
}
